module.exports={
  "name": "frontend-boilerplate",
  "description": "An opinionated blueprint environment to quick start new front-end codebases",
  "version": "1.0.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/mirabeau-nl/frontend-boilerplate.git"
  },
  "scripts": {
    "gulp": "node node_modules/gulp/bin/gulp.js",
    "start": "gulp dev",
    "dev": "gulp dev",
    "dist": "gulp dist",
    "test": "gulp test",
    "prettier": "prettier --config .prettierrc.json --check --debug-check ./**/*.{js,ts,(s)css,html}",
    "prettier:fix": "prettier --config .prettierrc.json ./**/*.{js,ts,(s)css,html} --write --cache --loglevel silent",
    "stylelint": "stylelint --config .stylelintrc.json ./**/*.{scss,vue} --formatter verbose",
    "stylelint:fix": "stylelint --config .stylelintrc.json ./**/*.{scss,vue} --formatter verbose --fix",
    "eslint": "eslint -c .eslintrc.json ./**/*.{js,ts,vue} --cache --cache-location ./dev-reports/.eslintcache",
    "eslint:dry": "eslint -c .eslintrc.json ./**/*.{js,ts,vue} --cache --cache-location ./dev-reports/.eslintcache --fix-dry-run",
    "eslint:fix": "eslint -c .eslintrc.json ./**/*.{js,ts,vue} --cache --cache-location ./dev-reports/.eslintcache --fix",
    "eslint:needles": "eslint -c .eslintrc.json ./**/*.{js,ts,vue} --report-unused-disable-directives",
    "preclean": "npm run del",
    "clean": "npm install",
    "postclean": "echo All node modules are re-installed! Happy coding !!!",
    "del": "npx rimraf node_modules package-lock.json"
  },
  "contributors": [
    "Bran van der Meer <bran.vd.meer@gmail.com> (http://bran.name/)",
    "Rik Schennink <rikschennink@gmail.com> (http://rikschennink.nl/)",
    "Niek Bosch <just.niek@gmail.com>",
    "Eric Weerstra <eweerstra@mirabeau.nl> (http://visualformation.com/)",
    "Arno Wolkers <awolkers@mirabeau.nl> (https://www.mirabeau.nl/)",
    "Leendert Ullersma <leendert.ullersma@gmail.com>",
    "Christiaan Stegeman <henkverdenk@hotmail.com>",
    "Sybren Wartna <sybren@gmail.com> (http://waarissyb.nl/)",
    "Wouter Kroes <wkroes@mirabeau.nl> (http://www.wouterkroes.nl/)",
    "Sanjay Twisk <stwisk@mirabeau.nl> (http://twisk-interactive.nl/)",
    "Peeke Kuepers <pkuepers@mirabeau.nl> (https://peeke.nl/)",
    "Bram Swier <bswier@mirabeau.nl> (https://www.mirabeau.nl/)",
    "Marius de Corte <mdecorte@gmail.nl> (https://marius.observer/)",
    "Cosmin Epureanu <cosmin.epureanu@gmail.com> (http://cosminepureanu.com/)",
    "Colin Aarts <hello@colinaarts.com> (https://colinaarts.com)",
    "Razvan Negrea <howl@wolfpilot.co> (http://www.wolfpilot.co/)",
    "Dave Bitter <dbitter@mirabeau.nl> (https://davebitter.com)"
  ],
  "readmeFilename": "README.md",
  "license": "BSD-3-Clause",
  "devDependencies": {
    "@babel/core": "^7.6.0",
    "@babel/eslint-parser": "^7.25.1",
    "@babel/plugin-external-helpers": "^7.2.0",
    "@babel/plugin-proposal-class-properties": "^7.5.5",
    "@babel/plugin-proposal-object-rest-spread": "^7.5.5",
    "@babel/plugin-transform-async-to-generator": "^7.25.9",
    "@babel/plugin-transform-runtime": "^7.6.0",
    "@babel/polyfill": "^7.6.0",
    "@babel/preset-env": "^7.6.0",
    "@babel/register": "^7.6.0",
    "autoprefixer": "^8.3.0",
    "babelify": "^10.0.0",
    "browser-sync": "^2.26.7",
    "browserify": "^16.5.0",
    "del": "^3.0.0",
    "dotenv": "^5.0.1",
    "errorify": "^0.3.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^8.10.0",
    "glob": "^7.1.4",
    "gulp": "4.0.0",
    "gulp-changed": "^4.0.3",
    "gulp-clean-css": "^4.3.0",
    "gulp-data": "^1.3.1",
    "gulp-ext-replace": "^0.3.0",
    "gulp-filter": "^5.1.0",
    "gulp-if": "^3.0.0",
    "gulp-imagemin": "^7.0.0",
    "gulp-mocha": "^5.0.0",
    "gulp-nunjucks-render": "^2.2.3",
    "gulp-postcss": "^10.0.0",
    "gulp-rename": "^2.0.0",
    "gulp-sass": "^5.1.0",
    "gulp-sourcemaps": "^3.0.0",
    "gulp-svg-sprite": "^2.0.3",
    "gulp-transform": "^3.0.5",
    "gulp-uglify": "^3.0.2",
    "gulp-util": "^3.0.7",
    "gulp-zip": "^4.1.0",
    "highlight.js": "^11.10.0",
    "ignore": "^3.3.7",
    "js-beautify": "^1.15.1",
    "js-yaml": "^4.1.0",
    "marked": "^4.0.1",
    "moment-timezone": "^0.5.46",
    "nunjucks-includeData": "0.0.9",
    "prettier": "^3.2.5",
    "require-globify": "^1.4.1",
    "sass": "1.77.6",
    "stylelint": "^16.9.0",
    "stylelint-config-prettier-scss": "^1.0.0",
    "stylelint-config-recommended-scss": "^14.1.0",
    "stylelint-config-standard-scss": "^13.1.0",
    "stylelint-selector-bem-pattern": "^4.0.1",
    "vinyl": "^2.2.1",
    "vinyl-buffer": "^1.0.1",
    "vinyl-ftp": "^0.6.1",
    "vinyl-source-stream": "^2.0.0",
    "watchify": "^3.11.1",
    "zen-observable": "^0.7.1"
  },
  "dependencies": {
    "@babel/runtime": "^7.6.0",
    "@dotsunited/load-css-polyfill": "^1.2.0",
    "body-scroll-lock": "^2.6.4",
    "chart.js": "^4.2.1",
    "chartjs-adapter-moment": "^1.0.1",
    "chartjs-plugin-datalabels": "^2.2.0",
    "colcade": "^0.2.0",
    "element-matches-polyfill": "^1.0.0",
    "element-qsa-scope": "^1.1.0",
    "eligrey-classlist-js-polyfill": "^1.2.20180112",
    "flickity": "^2.2.1",
    "flickity-as-nav-for": "^2.0.1",
    "flickity-fade": "^1.0.0",
    "focus-visible": "^5.0.2",
    "glightbox": "^3.0.5",
    "intersection-observer": "^0.12.2",
    "lazysizes": "^5.3.2",
    "mdn-polyfills": "^5.18.0",
    "moment": "^2.30.1",
    "normalize-scss": "^8.0.0",
    "object-fit-images": "^3.2.4",
    "svg4everybody": "^2.1.9",
    "webfontloader": "^1.6.28"
  }
}
